<template>
    <div class="update-rule-selector">
        <form class="scheduling-form container" v-on:submit.prevent="handleSubmit" ref="form">
            <div class="row">
                <div class="col-md-8 offset-md-2">
                    <h3>{{ title }}</h3>
                </div>
            </div>
            <div class="row">
                <div class="col-md-8 offset-md-2">
                    <div v-for="obj in ruleOptions" class="form-check">
                        <input class="form-check-input" type="radio" name="update_rule" :id="obj.id" :value="obj.value">
                        <label class="form-check-label" :for="obj.id">{{ obj.label }}</label>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-7 col-md-5 offset-md-2">
                    <button class="btn btn-primary btn-block">Confirmar</button>
                </div>
                <div class="col-5 col-md-3">
                    <button class="btn btn-outline-primary btn-block" v-on:click.prevent="onCancel">Cancelar</button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    props: {
        title: String,
        onSelect: Function,
        onCancel: Function
    },
    computed: {
        ruleOptions(){
            const rules = [
                { value: 'this_only', label: 'Apenas este agendamento' },
                { value: 'this_and_following', label: 'Este e os próximos agendamentos' },
                { value: 'all', label: 'Todos os agendamentos' }
            ];

            return rules.map(obj => ({ ...obj, id: `update_rule_${obj.value}` }));
        }
    },
    methods: {
        handleSubmit(ev){
            const formData = new FormData(this.$refs.form);
            const value = formData.get('update_rule');

            if(value){
                this.onSelect(value);
            }
            else{
                alert('Selecione uma das opções!');
            }
        }
    }
}
</script>

<style>
</style>
